import { IconButton } from "@mui/material";
import CloneIcon from "@mui/icons-material/Queue";
import { Link } from "react-router-dom";
import { useCreatePath, useRecordContext, useResourceContext } from "react-admin";
import { stringify } from "query-string";

export function CloneIconButton() {
  const resource = useResourceContext();
  const record = useRecordContext();
  const createPath = useCreatePath();

  if (!record) {
    return null;
  }

  const { id: _, ...recordWithoutId } = record;

  return (
    <IconButton
      component={Link}
      to={{
        pathname: createPath({ resource, type: "create" }),
        search: stringify({ source: JSON.stringify(recordWithoutId) }),
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <CloneIcon />
    </IconButton>
  );
}
